export default __webpack_public_path__ + "static/media/emptyResult.b253cd3f.svg";